import { useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import GroupsAsExhibitor from "../../Components/GroupsViews/GroupsAsExhibitor";
import Spinner from "../../Components/Spinner";
import UserContext from "../../Context/UserContext";
import GroupsAsOrganizer from "../../Components/GroupsViews/GroupsAsOrganizer";
import GroupsAsStaff from "../../Components/GroupsViews/GroupsAsStaff";

export default function GroupsPage() {
  const {role} = useParams()
  const {user} = useContext(UserContext)
  const [loading, setLoading] = useState(true)
  const navigate = useNavigate()
  
  useEffect(()=>{
    if(user !== 'checking'){
      switch (role) {
        case 'organizer':
          break;
        case 'exhibitor':
          break;
        default:
          break;
      }
      setLoading(false)
    }
  },[navigate, user, role])
 
  return(<div className="container mx-auto px-4">
    {loading?
    <div className="py-5">
    <Spinner/>
    </div>
    :
    <>
    {role==='organizer'?
    <>
    <GroupsAsOrganizer/>
    </>
    :<></>}
    {role==='exhibitor'?
    <GroupsAsExhibitor/>:<></>}
    {role==='staff'?
    <GroupsAsStaff/>:<></>}
    </>}
  </div>)
}